module.exports = __webpack_public_path__ + "img/whatsapp.8e7cf54a.svg";